import { UserStateApi } from '@core/api/model/user/user-api.model';
import { IndividualUserState } from './individual-user.model';

export const UserStateDirectory: { [prop in UserStateApi]: IndividualUserState } = {
  A: 'REGISTERED',
  B: 'CANCELLED',
  PA: 'PENDING',
};
